function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { useMemo } from "react";
import { useBuildStyleWithTheme } from "../ThemeProvider/useBuildStyleWithTheme";
var buildStyle = function(param, param1) {
    var backgroundColor = param.backgroundColor, borderColor = param.borderColor, depth = param.depth, size = param.size, spacing = param.spacing, experimentalBlocks = param.experimentalBlocks, readingDirection = param1.readingDirection, start = param1.start;
    var _base;
    return {
        'magazine-base': _objectSpread({}, readingDirection, {
            backgroundColor: (_base = experimentalBlocks === null || experimentalBlocks === void 0 ? void 0 : experimentalBlocks.backgroundColor.base) !== null && _base !== void 0 ? _base : backgroundColor.base,
            borderRadius: size.border.radius.threeX,
            outline: 'none',
            boxSizing: 'border-box',
            margin: 0,
            overflow: 'auto',
            padding: spacing[3],
            boxShadow: "\n      ".concat(depth.boxShadow['3'].xOffset, "\n      ").concat(depth.boxShadow['3'].yOffset, "\n      ").concat(depth.boxShadow['3'].blurRadius, "\n      ").concat(depth.boxShadow['3'].spreadRadius, "\n      ").concat(depth.boxShadow['3'].color),
            display: 'block',
            textAlign: start.direction,
            position: 'absolute'
        }),
        'magazine-option-linebreak': {
            borderTop: "".concat(size.border.base, "px solid ").concat(borderColor.soft),
            marginTop: spacing[3],
            marginBottom: spacing[3],
            width: '100%',
            display: 'block'
        }
    };
};
var useStyle = function(param) {
    var isRtl = param.isRtl;
    var style = useBuildStyleWithTheme(buildStyle, {
        isRtl: isRtl
    });
    return useMemo(function() {
        return {
            baseStyles: _objectSpread({}, style === null || style === void 0 ? void 0 : style['magazine-base']),
            lineBreakStyles: _objectSpread({}, style === null || style === void 0 ? void 0 : style['magazine-option-linebreak'])
        };
    }, [
        style
    ]);
};
export default useStyle;
